import React from 'react'
import { FaLinkedin, FaGithub, FaYoutube, FaMedium, FaBlogger } from 'react-icons/fa'
import socialLinks from '../data/socialLinks.json'

export default function SocialLinks() {
  const getIcon = (name, color, bgColor) => {
    const iconClasses = `w-16 h-16 lg:w-19 lg:h-19 rounded-full flex items-center justify-center` // Ensure flexbox alignment
    const iconStyle = {
      color: color,
      backgroundColor: bgColor,
      padding: '1rem'
    }

    // Apply a special style for GitHub if it's not aligned properly
    const githubStyle = {
      ...iconStyle,
      // Adjust margin or padding as necessary to align the GitHub icon
      // For example, if GitHub icon is higher, you might need to add marginBottom
      marginBottom: name === 'Github' ? '0.1rem' : undefined
    }

    switch (name) {
      case 'Youtube':
        return <FaYoutube className={iconClasses} style={iconStyle} />
      case 'Medium':
        return <FaMedium className={iconClasses} style={iconStyle} />
      case 'Linkedin':
        return <FaLinkedin className={iconClasses} style={iconStyle} />
      case 'Github':
        return <FaGithub className={iconClasses} style={githubStyle} />
      case 'Blogger':
        return <FaBlogger className={iconClasses} style={iconStyle} />
      default:
        return null
    }
  }

  return (
    <div className='flex flex-col items-center lg:flex-row lg:space-x-6'>
      {socialLinks.map(link => (
        <a
          key={link.name}
          href={link.href}
          target='_blank'
          rel='noopener noreferrer'
          aria-label={`Follow me on ${link.name}`}
          className='my-2 lg:my-0 flex items-center justify-center rounded-full overflow-hidden'
        >
          {getIcon(link.name, link.color, link.bgColor)}
          <span className='text-sm ml-2 mt-2 lg:hidden'>{link.name}</span>
        </a>
      ))}
    </div>
  )
}
